import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

function Loader(props) {
    return <CircularProgress className={props.className} size={!isNaN(props.size) && props.size > 0 ? props.size : 20} />;
}

export default Loader;